<div
  class="uni-nav-item-toggle  uni-nav-item-toggle--{{ toggleType }}"
  [ngClass]="{ 'is-expanded': isExpanded }"
>
  <i class="far fa-chevron-down"></i>
</div>
